// extracted by mini-css-extract-plugin
export default {"cardTitle":"style_cardTitle__Mx+fF","separador":"style_separador__Qt4Go","cabecalho":"style_cabecalho__meWch"};